var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * Lobby player presence. One Player per connected client in LobbyState.players.
 * Position is broadcast on each lobby tick; clients render avatars at (x, y, z)
 * facing rotY (radians around the Y axis).
 */
export class Player extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.displayName = "";
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.rotY = 0;
        this.avatarUrl = "";
        // Stable identity for cross-session features (e.g. persistent local mute).
        // Empty for guests; clients send their connected wallet pubkey on join.
        this.pubkey = "";
        // Spectators have no playable avatar: no collision, no broadcast position,
        // no game-action HUD, listen-only voice. Set on join, never mutated.
        this.isSpectator = false;
        // Avatar capsule color as `#rrggbb`. Empty until the client picks (or hashes
        // a default from pubkey/sessionId); validated server-side against PLAYER_COLOR_PALETTE.
        this.colorHex = "";
        // True when the verified `pubkey` holds a non-zero balance of the launch
        // token mint. Server-authoritative (checked after pubkey attestation, then
        // refreshed on a timer). Gates the custom-name perk + the holder badge.
        this.isHolder = false;
    }
}
__decorate([
    type("string")
], Player.prototype, "id", void 0);
__decorate([
    type("string")
], Player.prototype, "displayName", void 0);
__decorate([
    type("number")
], Player.prototype, "x", void 0);
__decorate([
    type("number")
], Player.prototype, "y", void 0);
__decorate([
    type("number")
], Player.prototype, "z", void 0);
__decorate([
    type("number")
], Player.prototype, "rotY", void 0);
__decorate([
    type("string")
], Player.prototype, "avatarUrl", void 0);
__decorate([
    type("string")
], Player.prototype, "pubkey", void 0);
__decorate([
    type("boolean")
], Player.prototype, "isSpectator", void 0);
__decorate([
    type("string")
], Player.prototype, "colorHex", void 0);
__decorate([
    type("boolean")
], Player.prototype, "isHolder", void 0);
//# sourceMappingURL=Player.js.map